import { render, staticRenderFns } from "./greenfilmdocs.vue?vue&type=template&id=6758863e&scoped=true&"
import script from "./greenfilmdocs.vue?vue&type=script&lang=js&"
export * from "./greenfilmdocs.vue?vue&type=script&lang=js&"
import style0 from "./greenfilmdocs.vue?vue&type=style&index=0&id=6758863e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6758863e",
  null
  
)

export default component.exports